import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const ConfirmationPage: React.FC = () => {
  const [params] = useSearchParams();
  const decision = params.get('decision') as 'accepted' | 'rejected' | null;
  const offerNumber = params.get('offerNumber') ?? '';

  const isAccepted = decision === 'accepted';

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: 'var(--surface)',
          borderRadius: '16px',
          padding: '48px 40px',
          maxWidth: '480px',
          width: '100%',
          boxShadow: 'var(--shadow-xl)',
          border: '1px solid var(--border)',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>
          {isAccepted ? '✅' : '❌'}
        </div>

        <h2
          style={{
            fontSize: '22px',
            fontWeight: 800,
            marginBottom: '12px',
            color: isAccepted ? '#065f46' : '#991b1b',
          }}
        >
          Offer {isAccepted ? 'Accepted' : 'Declined'}
        </h2>

        {offerNumber && (
          <div
            style={{
              background: '#f8f9fa',
              borderRadius: '6px',
              padding: '8px 16px',
              display: 'inline-block',
              fontWeight: 700,
              fontSize: '14px',
              marginBottom: '16px',
              color: '#1a1a2e',
            }}
          >
            {offerNumber}
          </div>
        )}

        <p style={{ color: '#6c757d', fontSize: '14px', lineHeight: 1.6 }}>
          {isAccepted
            ? 'Thank you! Your acceptance has been recorded. A Salam representative will be in touch shortly to proceed with your service activation.'
            : 'You have declined this offer. If you change your mind or need assistance, please contact your Salam representative.'}
        </p>

        <div
          style={{
            marginTop: '32px',
            padding: '16px',
            background: isAccepted ? '#d1fae5' : '#fee2e2',
            borderRadius: '8px',
            fontSize: '13px',
            color: isAccepted ? '#065f46' : '#991b1b',
          }}
        >
          {isAccepted
            ? 'Reference number saved. Please keep this page for your records.'
            : 'No further action is required from your side.'}
        </div>
      </div>
    </div>
  );
};
